import { render, staticRenderFns } from "./EmptyCard.vue?vue&type=template&id=704acd97&scoped=true&"
import script from "./EmptyCard.vue?vue&type=script&lang=js&"
export * from "./EmptyCard.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCard.vue?vue&type=style&index=0&id=704acd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704acd97",
  null
  
)

export default component.exports